<ag-grid-angular
  class="ag-theme-material flex-fill-container-y communication-hub-table-grid-ag-grid"
  [columnDefs]="columnDefs"
  [gridOptions]="gridOptions"
/>

<ng-template #statusTemplate let-data>
  <div class="d-flex align-items-center">
    <pill [color]="data.color" [value]="data.value" size="small" />
  </div>
</ng-template>

<ng-template #booleanIconTemplate let-data>
  <div class="d-flex align-items-center">
    @if (data.show) {
      <anduin-icon name="check-circle" [height]="18" [width]="18" stroke="#31AD98" />
    } @else {
      <p>{{ NULL_DATA_STRING }}</p>
    }
  </div>
</ng-template>

<ng-template #bounceReasonTemplate let-data>
  <p>{{ data }}</p>
</ng-template>
